import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const StatusSuppTickets = () => {
  return (
    <SettingsMetaData propertyName={"Status_Support_Tickets"} viewPropertyName={"Status"} />
  );
};
export default StatusSuppTickets;